'use strict';
import answers from './answer-store';

global.page_state = {};

// The AnswerStore does NOT write through to `page_state.form_data`.
//
// It did, briefly. `page_state.form_data` is the server's load-time snapshot and
// the Handlebars `answer`/`ans`/`ifanswerexists` helpers read it, so making it
// mutate during a page changed what later markup renders: any widget rendered
// after a store write (dyngrid phases, multiple-colorpicker phases, popups)
// picked up the mutated value — or, via `ifanswerexists`, a different branch
// entirely — and rendered it into an input's `value=`. Submit scrapes the DOM,
// so that reached the payload as an empty string.
//
// The store has no production reader yet (only the RR-4 shadow compare), so it
// stays a pure shadow until RR-5/RR-6 introduce one deliberately.

global.clear_spd_elements_state = function () {
  /**
   * Clear and hide SPD (GDPR) consent content
   */
  $('.spd-consent-text p').text('');
  $('.spd-content').hide();
  if (mainNav) {
    mainNav.skipButton.hide();
  }
};

export function init_page_state(res) {
  if (res.init_state) {
    for (var name in res.init_state) {
      page_state[name] = res.init_state[name];
    }
  }
  // Seed the store from the API response on every load.
  var seed = (res.init_state && res.init_state.form_data) || {};
  answers.reset(seed);
  // The helpers index into this unguarded; a response without `form_data` must
  // not turn every `{{answer}}` into a TypeError.
  page_state.form_data = page_state.form_data || {};
  // Snapshot how many answers existed AT LOAD, which is what
  // `Grid/helpers/displaymax.js` needs for "is this the first question?".
  // Equivalent to the live `form_data` size now that nothing mutates it, but
  // stated explicitly so the answer does not depend on that staying true.
  page_state.initial_answer_count = Object.keys(seed).length;
}

export function clear_page_state() {
  $(window).off('resize.videoPlayer orientationChanged.videoPlayer');
  clear_spd_elements_state();
  $(page_state).unbind();
  page_state = {};
  page_state.vardata = {};
  page_state.page_events = {};
  page_state.initial_answer_count = 0;
  // Clear the store alongside page_state so answers never leak across loads.
  answers.reset({});
}
